import { Component, VERSION } from '@angular/core';
import { OverlayAlertRef, OverlayAlertService } from '@gridscale/ingrid/components/overlay-alert';
import _ from 'lodash';
import { distinctUntilChanged, filter, map, take, } from 'rxjs/operators';
import { ButtonModule } from '@gridscale/ingrid/elements/button';
import { AccordionModule } from '@js/primeng17/accordion';
import { NgFor, AsyncPipe, JsonPipe } from '@angular/common';
import { CopyClipboardModule } from '@gridscale/ingrid/components/copy-clipboard';
import { InlineAlertModule } from '@gridscale/ingrid/elements/inline-alert';
import { FeatureService } from '../../../@shared/services/feature.service';
import { UserRoleService } from '../../../@shared/services/user.role.service';
import { UserStoreService } from '../../../@store/userstore/userstore.service';
import { RegistryService } from '../../../@shared/services/registry.service';

@Component({
    selector: 'app-debug-center',
    templateUrl: './debug-center.component.html',
    styleUrls: ['./debug-center.component.scss'],
    imports: [
        AccordionModule,
        AsyncPipe,
        ButtonModule,
        CopyClipboardModule,
        InlineAlertModule,
      JsonPipe,
      NgFor,
    ]
})
export class DebugCenterComponent {
  panelVersion = this.registry.get('gs_version');
  panelVersionHash = this.registry.get('gs_version_hash');
  datacenter = '<!--#echo var="ssiCTRL_PLANE"-->';
  angularVersion = VERSION.full;

  userRole$ = this.userroleService.role$.pipe(
    distinctUntilChanged(),
    map(role => role.user_role)
  );
  activeFeatureFlags$ = this.featureService.getAllFeatures$().pipe(
    map(allFeatures => Object.keys(_.pickBy(allFeatures, f => f === true)))
  );
  disabledFeaturesDueDependencies: string[] = [];

  userStoreData$ = this.userStoreService.loaded$.pipe(
    filter(loaded => !!loaded),
    map(() => this.userStoreService.getAll())
  );

  constructor(
    private overlayAlertService: OverlayAlertService,
    private userStoreService: UserStoreService,
    private ref: OverlayAlertRef,
    private userroleService: UserRoleService,
    private featureService: FeatureService,
    private registry: RegistryService,
  ) {

  }




  resetUserStore() {
    this.ref.close();

    this.overlayAlertService
      .confirm('Sure?', 'You will loose all your Panel Settings')
      .pipe(take(1))
      .subscribe(confirmed => {
        if (confirmed) {
          this.userStoreService
            .clear()
            .pipe(take(1))
            .subscribe(() => {
              this.overlayAlertService.alert('User store cleared', 'Done.');
            });
        }
      });
  }


}
